import { render, staticRenderFns } from "./PetHealthBookItem.vue?vue&type=template&id=42938aee&scoped=true&"
import script from "./PetHealthBookItem.vue?vue&type=script&lang=js&"
export * from "./PetHealthBookItem.vue?vue&type=script&lang=js&"
import style0 from "./PetHealthBookItem.vue?vue&type=style&index=0&id=42938aee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42938aee",
  null
  
)

export default component.exports